<!--
  Tarjeta de imagen insertada (foto o imagen principal del apartado): miniatura (slot),
  título + pie/descripción y columna de acciones (ampliar, mover arriba/abajo, cambiar,
  eliminar). Presentación reutilizable; emite eventos para que el padre decida la lógica.
-->
<template>
  <div class="ric">
    <div class="ric-thumb" @click="$emit('expand')"><slot name="thumb" /></div>

    <div class="ric-body">
      <div class="ric-meta"><slot name="meta">{{ meta }}</slot></div>
      <div class="ric-fields">
        <b-field :label="titleLabel" class="mb-0">
          <b-input v-model="localTitle" size="is-small" :placeholder="titlePlaceholder" icon-pack="fas" icon="heading" />
        </b-field>
        <b-field :label="captionLabel" class="mb-0">
          <b-input v-model="localCaption" size="is-small" :placeholder="captionPlaceholder" icon-pack="fas" icon="align-left" />
        </b-field>
      </div>
    </div>

    <div class="ric-acts">
      <button class="ric-iconbtn" title="Ampliar" @click="$emit('expand')"><b-icon pack="fas" icon="expand-arrows-alt" size="is-small" /></button>
      <template v-if="showMove">
        <button class="ric-iconbtn" title="Mover arriba" :disabled="!canMoveUp" @click="$emit('move-up')"><b-icon pack="fas" icon="arrow-up" size="is-small" /></button>
        <button class="ric-iconbtn" title="Mover abajo" :disabled="!canMoveDown" @click="$emit('move-down')"><b-icon pack="fas" icon="arrow-down" size="is-small" /></button>
      </template>
      <button class="ric-iconbtn" title="Cambiar imagen" @click="$emit('replace')"><b-icon pack="fas" icon="sync-alt" size="is-small" /></button>
      <button class="ric-iconbtn" title="Eliminar" @click="$emit('remove')"><b-icon pack="fas" icon="trash-alt" size="is-small" /></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'report-image-card',

  props: {
    meta: { type: String, default: '' },
    title: { type: String, default: '' },
    caption: { type: String, default: '' },
    titleLabel: { type: String, default: 'Título' },
    captionLabel: { type: String, default: 'Pie de foto' },
    titlePlaceholder: { type: String, default: '' },
    captionPlaceholder: { type: String, default: '' },
    showMove: { type: Boolean, default: true },
    canMoveUp: { type: Boolean, default: true },
    canMoveDown: { type: Boolean, default: true },
  },

  data() {
    return { localTitle: this.title, localCaption: this.caption }
  },

  watch: {
    // Sincroniza con el padre en ambos sentidos sin bucle (guarda por igualdad).
    title(v) { if (v !== this.localTitle) this.localTitle = v },
    caption(v) { if (v !== this.localCaption) this.localCaption = v },
    localTitle(v) { this.$emit('update:title', v) },
    localCaption(v) { this.$emit('update:caption', v) },
  },
}
</script>

<style scoped>
.ric { display: grid; grid-template-columns: 128px 1fr auto; gap: 14px; border: 1px solid #e2e7ef; border-radius: 6px; padding: 12px; align-items: start; }
.ric-thumb { width: 128px; aspect-ratio: 4/3; border-radius: 5px; overflow: hidden; border: 1px solid #e2e7ef; cursor: zoom-in; }
.ric-thumb >>> svg { width: 100%; height: 100%; display: block; }
.ric-meta { font-size: 12px; color: #697289; margin-bottom: 8px; }
.ric-fields { display: grid; grid-template-columns: minmax(150px, 240px) 1fr; gap: 12px; }
.ric ::v-deep .field > .label { font-size: 0.72rem; margin-bottom: 0.2rem; }
.ric-acts { display: grid; grid-template-columns: repeat(2, auto); gap: 4px; align-content: start; }
.ric-iconbtn { width: 28px; height: 28px; border: none; background: none; color: #697289; border-radius: 5px; cursor: pointer; display: grid; place-items: center; }
.ric-iconbtn:hover { background: #f2f6fd; color: #1b3d94; }
.ric-iconbtn:disabled { opacity: .35; cursor: default; }
@media (max-width: 620px) {
  .ric { grid-template-columns: 1fr; }
  .ric-thumb { width: 100%; max-width: 220px; }
  .ric-fields { grid-template-columns: 1fr; }
}
</style>
